
import { computed, nextTick, } from 'vue';
import { uuid } from 'vue-uuid';
import { useI18n } from 'vue-i18n';
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: 'text'
    },
    maxlength: {
      type: Number,
      default: 9999,
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: String || Number,
      default: '',
    },
    isError: {
      type: Boolean,
      default: false,
      require: false,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '42',
    },
    bg: {
      type: String,
      default: 'default',
    },
    id: {
      type: String,
      default: '',
    },
    min: { //當input為date時，可選的最小日期
      type: String,
      default: undefined
    },
    error: {
      type: String,
      default: '',
      require: false,
    },
    minInt: { 
      type:  String,
      default: undefined
    },
    maxInt: { 
      type:  String,
      default: undefined
    },


  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const { value, id, } = props;
    let _posCursourStart =0;
    let target = null;


    const privateValue = computed({
      get: () => value,
      set: (val) => {
        
        emit('update:value', val.toString());
        nextTick(()=>{
          // console.log('go onkeydown');
          // 只有非 number 類型的 input 才支援 setSelectionRange
          if (target.type !== 'number') {
            target.setSelectionRange(_posCursourStart,_posCursourStart);
          }
          // console.log('sel',_posCursourStart)
        })
        
         
      }
    });
    // const handleInput = (event) => {
    //   let e = event.target;
    //   // const sel = e.selectionStart;
    //   // console.log('e',sel, e)
    //   // nextTick(()=>{
    //   //   e.setSelectionRange(sel,sel);
        
    //   // })
    // }
    const valueChange = () => {
      nextTick(()=>{
        
      })
    }
    const placeholderLocal = computed(() => {
      return t(`${props.placeholder}`)
    })


    const privateId = computed(() => {
      return id === '' ? uuid.v4() : id;
    })


    const styleAll = computed(() => {
      return [
        { 'style--error': props.isError },
        { 'style--error': props.error },
        { 'style--disable': props.isDisable }
      ]
    });

    const onkeydown = (event) => {
      let e = event.target;
      target = e;
      // console.log('event.keyCode',event.keyCode)
        if(event.keyCode === 8 ){
          // back or delete
          _posCursourStart = e.selectionStart - 1;
        
        }
        else if(event.keyCode === 46){
          _posCursourStart = e.selectionStart;
        }
        else{
          _posCursourStart = e.selectionStart + 1;
          
        }
      
      if (props.type == 'date') {
        return false
      }
      if (props.type == 'number') {
        // console.log('1234',event.target.value,props.minInt,props.maxInt )
        event = (event) ? event : window.event;
        var charCode = (event.which) ? event.which : event.keyCode; // 
        

        if (charCode == 189 || charCode == 110 || charCode == 109 || charCode == 107 || charCode == 187) {
          event.preventDefault();
        }
      }
      
      
    }

    const onkeyup = (event) => {
      target = event.target;
      // const sel = e.selectionStart;
      if (props.type == 'number') {
        let val = Number(target.value)
        let min = Number(props.minInt)
        let max = Number(props.maxInt)
        
        // console.log('????',val, min,max)
        if (min) {
          if (val < min) {
            emit('update:value', min.toFixed(4));
          }
          else {
            if (val < max) {
              emit('update:value', val.toFixed(4));
            }
          }
        }
        if (max) {
          if (val > max) {
            emit('update:value', max.toFixed(4));
          }
          else {
            if (val > min) {
              emit('update:value', val.toFixed(4));
            }
          }
        }
      }
      emit('onChange', event.target.value);
      // console.log('after onChange')
      // setTimeout(()=>{
        nextTick(()=>{
          // console.log('go');
          // 只有非 number 類型的 input 才支援 setSelectionRange
          if (event.target.type !== 'number') {
            event.target.setSelectionRange(_posCursourStart,_posCursourStart);
          }
          // console.log('sel',_posCursourStart)
        })
      // },2000)

    }


    const styleClass = computed(() => [
      props.bg,
      // props.error ? 'error' : ''
    ])


    return {
      privateValue,
      styleClass,
      privateId,
      styleAll,
      onkeydown,
      placeholderLocal,
      t,
      onkeyup,
      valueChange,
      // handleInput
    }

  },//end: setup
}


